import React, { useEffect, useLayoutEffect, useState } from "react";
import { useMedia } from "use-media";
import { useHistory } from "react-router-dom";
import common from "../../resources_catalog/js/common/common";
import side_by_side from "../../resources_catalog/images/hotel_japan/hotel_img_jp_11.jpg";
import right_arrow_gold from "../../resources_catalog/icons/ico_right_arrow_gold.svg";
import { getNewsDetailListTest, getNewsDetailList } from '../../const/index.js';
import { useStore } from "react-redux";
import CommonUtil from '../../common/commonUtil';
import { Link } from "react-router-dom";
import Const from "../../const/RTCC/Const";
import { useRtoaster } from "../../hooks/useRtoaster";

export const CatalogNewsDetailContainer = (props) => {
  const isWidePhone = useMedia({ maxWidth: "480px" });
  const isWideTablet = useMedia({ maxWidth: "960px" });
  const history = useHistory();
  const store = useStore();
  // news取得
  const news = store.getState().news.news;
  const [newsDetailInfo, setNewsDetailInfo] = useState({});
  const [linkList, setLinkList] = useState([]);

  // rtoasterタグ生成
  useRtoaster();

  //この関数は画面レンダリング前に動きます
  useLayoutEffect(() => {
  })

  //この関数は画面レンダリング後に動きます
  useEffect(() => {
    setLinkList([{ path: "/rtcc/catalog/home", label: "ホーム" }, { path: "/rtcc/catalog/newsAll", label: "お知らせ一覧" }]);

    // お知らせ詳細Apiリクエスト
    if (CommonUtil.getDomain() == Const.RELEASE_PATH) {
      common.doGet(getNewsDetailList + news + "/", {}, afterGetNewsDetailList);
    } else {
      common.doGet(getNewsDetailListTest + news + "/", {}, afterGetNewsDetailList);
    }
  }, []);

  // お知らせ一覧取得後処理
  const afterGetNewsDetailList = (res) => {
    if (res.data) {
      let data = {
        title: res.data.title,
        news_id: res.data.news_id,
        content: res.data.content,
        date: res.data.date
      }
      setNewsDetailInfo(data);
      if (document.getElementById("catalogNewsDetailContent")) {
        let element = document.getElementById("catalogNewsDetailContent");
        let content = CommonUtil.replaceNewLineChar(data.content);
        element.innerHTML = CommonUtil.replaceSpecialChar(content);
      }
    }
  };

  return (
    <div className="catalogNewsDetailWrap">
      <div className="catalogNewsDetail">
        {
          <div className="catalogContentsBlock">
            <h1 className="catalogNewsDetailTitle">{newsDetailInfo.title}</h1>
            <p className="catalogNewsDetailDate">{newsDetailInfo.date}</p>
            <div className="catalogNewsDetailContent" id="catalogNewsDetailContent">
            </div>
            <div className="catalogNewsDetailBack">
              <a href="/rtcc/catalog/newsAll">
                <p>一覧に戻る</p>
                <img src={right_arrow_gold} alt="" className="catalogNewsDetailBackImg" />
              </a>
            </div>
          </div>
        }
      </div>
      <div className={isWideTablet ? "none" : "catalogBreadCrumb"}>
        {linkList.map((value, index) => (
          <div key={"link" + index} style={{ display: "flex" }}>
            <Link to={value.path} className="link">{value.label}</Link>
            <div className="lastLabel">&gt;</div>
          </div>
        ))}
        <div className="lastLabel">{newsDetailInfo.title}</div>
      </div>
    </div>
  );
};
